var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayerPortrait17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.4583in",
    height: "1.4583in",
    viewBox: "0 0 37.042 37.042",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1506",
    x1: 54.811,
    x2: 91.853,
    y1: 32.815,
    y2: 32.815,
    gradientTransform: "translate(161.44 146.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3a995",
    offset: 0
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-216.25 -161.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.25,
    y: 161.12,
    width: 37.042,
    height: 37.042,
    ry: 2.0045,
    fill: "url(#linearGradient1506)",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#413e35"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 227.17,
    cy: 179.49,
    r: 2.3262,
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    transform: "scale(-1,1)",
    cx: -242.69,
    cy: 179.28,
    r: 2.3262,
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  })), /*#__PURE__*/React.createElement("path", {
    d: "m227.25 171.8c-0.32828 0.88555-0.50849 1.8443-0.50849 2.8468v2.2459c0 4.5145 3.6344 8.1489 8.1488 8.1489 4.5145 0 8.1488-3.6344 8.1488-8.1489v-2.2459c0-1.0025-0.18021-1.9613-0.50848-2.8468z",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    transform: "scale(-1,1)",
    cx: -242.8,
    cy: 176.81,
    r: 1.6339,
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 216.25 161.12)",
    d: "m70.447 24.08c0.19784 0 0.39511 0.003328 0.5918 0.007813 0.093187 0.001946 0.18635 0.00495 0.2793 0.007812 0.46324 0.014266 0.9238 0.039475 1.3809 0.076172-0.74267-0.059685-1.4934-0.091797-2.252-0.091797zm0 0c-0.75789 0-1.508 0.032215-2.25 0.091797 0.45706-0.036697 0.91762-0.061906 1.3809-0.076172 0.092412-0.002846 0.1847-0.005872 0.27734-0.007812 0.19692-0.004495 0.39372-0.007813 0.5918-0.007813zm-2.25 0.091797c-2.2855 0.18351-4.4893 0.64326-6.5801 1.3477 2.0907-0.70414 4.2948-1.1642 6.5801-1.3477zm-6.5801 1.3477c-1.2543 0.42258-2.4678 0.93265-3.6328 1.5234 1.1651-0.59068 2.3784-1.101 3.6328-1.5234zm-3.6328 1.5234c-0.38849 0.19701-0.77095 0.40254-1.1484 0.61719 0.37736-0.21451 0.76008-0.4203 1.1484-0.61719zm-1.1484 0.61719c-0.37717 0.21447-0.74959 0.43838-1.1152 0.66992 0.36583-0.23159 0.73787-0.45541 1.1152-0.66992zm-1.1152 0.66992c-0.36617 0.23187-0.726 0.47225-1.0801 0.7207 0.35377-0.24814 0.71424-0.48911 1.0801-0.7207zm-1.0801 0.7207c-0.34453 0.24176-0.68304 0.49109-1.0156 0.74805 0.33264-0.2569 0.67104-0.50634 1.0156-0.74805zm18.059-4.8789c2.2853 0.18348 4.4895 0.64351 6.5801 1.3477-2.0902-0.7042-4.2953-1.164-6.5801-1.3477zm6.5801 1.3477c1.2482 0.42042 2.4555 0.92863 3.6152 1.5156-1.1601-0.58739-2.3666-1.095-3.6152-1.5156zm3.6406 1.5273c0.38566 0.19569 0.76581 0.40021 1.1406 0.61328-0.37451-0.21296-0.75528-0.41768-1.1406-0.61328zm1.1406 0.61328c0.37122 0.21103 0.7376 0.43064 1.0977 0.6582-0.36034-0.22782-0.72614-0.44695-1.0977-0.6582zm1.123 0.67578c0.34909 0.22118 0.69315 0.45123 1.0312 0.6875-0.3384-0.23658-0.68184-0.46604-1.0312-0.6875zm-14.736 0.39258-1.5703 2.0254c0.41605 0.768 0.13117 1.7207-0.63672 2.1367l-25.283 20.74v5.5156c0 15.229 12.261 27.49 27.49 27.49 15.229 0 27.49-12.261 27.49-27.49v-5.5156l-25.281-20.74c-0.76789-0.41605-1.0528-1.3687-0.63672-2.1367l-1.5723-2.0254zm15.834 0.3418c0.34084 0.23969 0.67479 0.48566 1.0039 0.74024-0.32858-0.25422-0.66364-0.50085-1.0039-0.74024zm1.0215 0.75391c0.33044 0.25603 0.65454 0.52045 0.97266 0.79102-0.31814-0.27065-0.64219-0.5349-0.97266-0.79102zm-33.719 0.005859c-0.3277 0.25416-0.64928 0.51669-0.96484 0.78516 0.31566-0.26846 0.63704-0.531 0.96484-0.78516zm-1.0059 0.81836c-0.30589 0.26124-0.60445 0.53042-0.89844 0.80469 0.29413-0.27432 0.5924-0.5434 0.89844-0.80469zm35.738 0.001953c0.29028 0.24788 0.5759 0.5021 0.85547 0.76172-0.27978-0.25988-0.56497-0.51359-0.85547-0.76172zm-36.721 0.87891c-0.30114 0.28327-0.59476 0.57261-0.88281 0.86914 0.2877-0.29606 0.58206-0.58631 0.88281-0.86914zm37.74 0.035156c0.27845 0.26283 0.55114 0.53243 0.81836 0.80664-0.26745-0.27454-0.53965-0.5435-0.81836-0.80664zm-38.629 0.83984c-0.28989 0.29861-0.57347 0.60445-0.84961 0.91602 0.27639-0.31175 0.55944-0.61724 0.84961-0.91602zm39.506 0.025391c0.28173 0.29085 0.55552 0.58751 0.82422 0.89062-0.2683-0.30272-0.54293-0.60013-0.82422-0.89062zm-40.408 0.94922c-0.24439 0.27734-0.48168 0.56049-0.71484 0.84766 0.23312-0.28702 0.4705-0.57046 0.71484-0.84766zm41.285 0c0.2593 0.2942 0.51116 0.59514 0.75781 0.90039-0.24647-0.30506-0.49872-0.60636-0.75781-0.90039zm0.85156 1.0156c0.23242 0.29085 0.45904 0.58632 0.67969 0.88672-0.22081-0.30067-0.44708-0.59561-0.67969-0.88672zm-43.021 0.042969c-0.23356 0.29351-0.46201 0.59135-0.68359 0.89453 0.22188-0.30353 0.44972-0.6007 0.68359-0.89453zm-0.73242 0.96094c-0.21814 0.30035-0.42869 0.60658-0.63477 0.91602 0.20586-0.30902 0.41688-0.61605 0.63477-0.91602zm44.557 0.050781c0.21686 0.3 0.42796 0.60505 0.63281 0.91406-0.20469-0.30879-0.41613-0.61427-0.63281-0.91406zm0.72461 1.0547c0.21173 0.32368 0.417 0.65132 0.61523 0.98438-0.19818-0.33298-0.40356-0.66076-0.61523-0.98438zm-46.08 0.058594c-0.19428 0.2987-0.38358 0.60156-0.56641 0.9082 0.18303-0.30694 0.37189-0.60923 0.56641-0.9082zm46.748 1.0156c0.1976 0.33489 0.38866 0.67563 0.57226 1.0195-0.18391-0.34455-0.3743-0.68402-0.57226-1.0195zm-47.396 0.03125c-0.1985 0.33744-0.38992 0.67884-0.57422 1.0254 0.18419-0.34626 0.37585-0.68823 0.57422-1.0254zm-0.62109 1.1133c-0.17756 0.33685-0.34791 0.67841-0.51172 1.0234 0.16386-0.34507 0.33409-0.68656 0.51172-1.0234zm48.674 0.033203c0.17255 0.32836 0.33856 0.65997 0.49805 0.99609-0.15937-0.3359-0.32564-0.66794-0.49805-0.99609zm0.58789 1.1875c0.15165 0.3261 0.29645 0.6553 0.43555 0.98828-0.13905-0.33286-0.28395-0.66229-0.43555-0.98828zm-49.887 0.042969c-0.14328 0.30952-0.28207 0.62181-0.41406 0.9375 0.13211-0.31593 0.27065-0.62776 0.41406-0.9375zm50.422 1.1895c0.1399 0.34421 0.27417 0.69188 0.40039 1.043-0.12623-0.35107-0.26049-0.69878-0.40039-1.043zm-50.957 0.048828c-0.12571 0.311-0.24676 0.6248-0.36133 0.94141 0.11457-0.31659 0.23561-0.63042 0.36133-0.94141zm51.404 1.125c0.12772 0.36102 0.24839 0.72588 0.36133 1.0938-0.11309-0.36842-0.23341-0.7322-0.36133-1.0938zm-51.848 0.050782c-0.12065 0.34314-0.23644 0.6878-0.34375 1.0371 0.10721-0.3489 0.22323-0.69437 0.34375-1.0371zm52.273 1.2598c0.10536 0.35358 0.20546 0.70887 0.29688 1.0684-0.091372-0.35931-0.19158-0.71494-0.29688-1.0684zm-52.697 0.050782c-0.099252 0.33548-0.19453 0.67289-0.28125 1.0137 0.086787-0.34103 0.18191-0.67795 0.28125-1.0137zm53.045 1.2305c0.090718 0.3691 0.17623 0.74034 0.25195 1.1152-0.075712-0.37478-0.16125-0.74624-0.25195-1.1152zm-53.391 0.046875c-0.086233 0.35352-0.16775 0.70954-0.24024 1.0684 0.072533-0.35905 0.15394-0.71462 0.24024-1.0684zm-0.27539 1.248c-0.076114 0.39013-0.1436 0.78374-0.20312 1.1797 0.059552-0.39624 0.12696-0.78928 0.20312-1.1797zm53.953 0c0.076152 0.39041 0.14358 0.78345 0.20312 1.1797-0.05953-0.39595-0.12701-0.78956-0.20312-1.1797zm-54.17 1.2832c-0.059767 0.40801-0.11253 0.81868-0.1543 1.2324 0.041742-0.41374 0.094554-0.82442 0.1543-1.2324zm54.387 0c0.062192 0.42479 0.11748 0.8522 0.16016 1.2832-0.042696-0.43083-0.097955-0.85857-0.16016-1.2832zm0.16016 1.2832c0.045006 0.45458 0.078792 0.91208 0.10156 1.373-0.022815-0.46128-0.056482-0.91816-0.10156-1.373zm0.10156 1.373c0.022739 0.46032 0.035124 0.92447 0.035156 1.3906-6.4e-5 -0.46607-0.012393-0.93039-0.035156-1.3906zm-54.814-1.2891c-0.040062 0.41711-0.072385 0.83535-0.09375 1.2578 0.021332-0.42217 0.053744-0.841 0.09375-1.2578zm-0.097657 1.3613c-0.020463 0.43651-0.033142 0.87663-0.033203 1.3184 3.1e-5 -0.44193 0.012749-0.88166 0.033203-1.3184z",
    fill: "#615b4c",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    transform: "scale(-1,1)",
    cx: -242.37,
    cy: 179.5,
    r: 1.6339,
    fill: "#413e35",
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.86,
    cy: 180.4,
    r: 1.6339,
    fill: "#413e35",
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "scale(-1,1)",
    cx: -238.43,
    cy: 176.32,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "scale(-1,1)",
    cx: -231.36,
    cy: 176.32,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#413e35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m231.36 175.78a0.885 1.2626 0 0 0-0.88521 1.2624 0.885 1.2626 0 0 0 0.12867 0.65526 2.0398 1.4861 0 0 0 0.75654 0.10646 2.0398 1.4861 0 0 0 0.75551-0.10594 0.885 1.2626 0 0 0 0.12919-0.65578 0.885 1.2626 0 0 0-0.8847-1.2624zm7.0693 0a0.885 1.2626 0 0 0-0.88522 1.2624 0.885 1.2626 0 0 0 0.15761 0.71934 2.0398 1.4861 0 0 0 0.72761 0.0977 2.0398 1.4861 0 0 0 0.72709-0.0982 0.885 1.2626 0 0 0 0.15761-0.71882 0.885 1.2626 0 0 0-0.8847-1.2624z",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.89 167.5c0.30821 0 0.61108 0.021 0.90899 0.0579l-1.3248 1.7076c0.11008 0.2032 0.0347 0.45526-0.16847 0.56534l-6.6892 5.4878v-0.5457c0-4.0295 3.244-7.2729 7.2734-7.2729z",
    stopColor: "#000000",
    strokeOpacity: 0.019685,
    strokeWidth: 5.324,
    style: {
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.89 167.5c-0.30821 0-0.61108 0.021-0.90899 0.0579l1.3248 1.7076c-0.11008 0.2032-0.0347 0.45526 0.16847 0.56534l6.6892 5.4878v-0.5457c0-4.0295-3.244-7.2729-7.2734-7.2729z",
    stopColor: "#000000",
    strokeOpacity: 0.019685,
    strokeWidth: 5.324,
    style: {
      paintOrder: "markers fill stroke"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 223.81,
    y: 170.94,
    width: 21.93,
    height: 0.83429,
    ry: 0,
    fill: "#968c77",
    stopColor: "#000000",
    strokeOpacity: 0.019685,
    strokeWidth: 5.1584,
    style: {
      paintOrder: "markers fill stroke"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 228.02,
    y: 174.25,
    width: 6.2594,
    height: 4.1125,
    ry: 2.0562,
    fill: "none",
    stopColor: "#000000",
    stroke: "#413e35",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  })), /*#__PURE__*/React.createElement("path", {
    d: "m229.1 166.03h11.38c0.18387 0 0.30422 0.13838 0.33192 0.32569l0.70847 4.7894c0.0326 0.22007-0.16588 0.4023-0.37194 0.4023h-12.753c-0.20607 0-0.4061-0.18251-0.37196-0.4023l0.74391-4.7894c0.0281-0.18136 0.14802-0.32569 0.33192-0.32569z",
    fill: "#968c77",
    stopColor: "#000000",
    strokeOpacity: 0.019685,
    strokeWidth: 4.9372,
    style: {
      paintOrder: "markers fill stroke"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 235.43,
    y: 174.25,
    width: 6.2594,
    height: 4.1125,
    ry: 2.0562,
    fill: "none",
    stopColor: "#000000",
    stroke: "#413e35",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m234.35 176.28 1.0739-0.0145",
    fill: "none",
    stopColor: "#000000",
    stroke: "#413e35",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 232.75,
    y: 182.14,
    width: 3.9959,
    height: 16.021,
    fill: "#4f4b41",
    stopColor: "#000000",
    strokeOpacity: 0.019685,
    strokeWidth: 6.4272,
    style: {
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.04 186.96c-4.0295 0-7.2735 3.244-7.2735 7.2734v2.0045c0 0.66841 0.0911 1.3146 0.25838 1.9286h14.03c0.16728-0.61393 0.25838-1.2602 0.25838-1.9286v-2.0045c0-4.0295-3.244-7.2734-7.2735-7.2734z",
    fill: "#413e35",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.44,
    cy: 194.4,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.44,
    cy: 193.75,
    rx: 0.885,
    ry: 1.2626,
    fill: "#413e35",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#968c77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m236.75 183.46v14.701h-3.9956v-14.691a12.143 13.298 0 0 0-4.0468 1.5952 12.143 13.298 0 0 0-6.0715 11.517v1.5818h24.287v-1.5818a12.143 13.298 0 0 0-6.0715-11.517 12.143 13.298 0 0 0-4.1016-1.6051z",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.55 179.91-0.80719 2.2278v5.5743h5.4012l2.8272-7.8021z",
    stopColor: "#000000",
    strokeOpacity: 0.019685,
    strokeWidth: 6.5846,
    style: {
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.48 179.79 2.8272 7.8021h5.4451v-5.4519l-0.85163-2.3502z",
    stopColor: "#000000",
    strokeOpacity: 0.019685,
    strokeWidth: 6.5846,
    style: {
      paintOrder: "markers fill stroke"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait17);
export default __webpack_public_path__ + "static/media/player-portrait-17.d4e69f211eb7c79a63f39572a203aba8.svg";
export { ForwardRef as ReactComponent };